import React from "react";

function TermsOfService() {
  return (
    <section className="hero">
      <div className="container">
        <h1>Terms of Service</h1>
        <p><strong>Crypto Trail Officer (CTO AI)</strong><br/>Last updated: 12.06.2025</p>
        <p>These Terms of Service govern your use of the <strong>Crypto Trail Officer (CTO AI)</strong> mobile application (&quot;the App&quot;). By using the app, you agree to these terms.</p>
        <p><strong>1. Description of Service</strong></p>
        <p>CTO AI is an AI-powered platform that provides blockchain and market analysis using APIs from Solana, Ethereum, and other crypto data sources. Some features may require a paid subscription.</p>
        <p><strong>2. Sign-Up and Login</strong></p>
        <ul>
          <li>Users can sign in using Google or Apple accounts.  </li>
          <li>You must provide accurate and up-to-date information when registering.</li>
        </ul>
        <p><strong>3. Paid Features</strong></p>
        <ul>
          <li>The app offers monthly and annual subscription options.  </li>
          <li>All payments are processed through the Apple App Store or Google Play Store.  </li>
          <li>Subscriptions auto-renew unless canceled by the user.  </li>
          <li>Refunds are subject to Apple/Google’s refund policies.</li>
        </ul>
        <p><strong>4. Advertisements</strong></p>
        <ul>
          <li>The free version of the app may display ads via Google AdMob.  </li>
          <li>Ad content is managed by third parties and not directly controlled by the developer.</li>
        </ul>
        <p><strong>5. Push Notifications</strong></p>
        <ul>
          <li>The app may send push notifications for market updates and analysis alerts.  </li>
          <li>Users can manage notification permissions from device settings.</li>
        </ul>
        <p><strong>6. Disclaimer</strong></p>
        <ul>
          <li>CTO AI does <strong>not</strong> provide financial or investment advice.  </li>
          <li>All data is sourced from third-party APIs and may not be guaranteed to be accurate.  </li>
          <li>Analysis results are informational only and should not be relied on for investment decisions.</li>
        </ul>
        <p><strong>7. Intellectual Property</strong></p>
        <p>All content, branding, design, and analysis systems are owned by the developer and may not be copied, reused, or distributed without permission.</p>
        <p><strong>8. Account Suspension</strong></p>
        <p>The developer reserves the right to suspend or delete user accounts in cases of abuse, spamming, or suspicious behavior.</p>
        <p><strong>9. Legal Jurisdiction</strong></p>
        <p>This service is governed by the laws of the Republic of Türkiye. Legal jurisdiction is Istanbul courts.</p>

      </div>
    </section>
  );
}

export default TermsOfService;
